import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { useContext } from "react";
import { AppContext } from "../../context/AppContext";
import { PanelChartClientData } from "../../components/Panel/PanelChartClientData";
import {PanelMatrixPartner} from "../../components/Panel/PanelMatrixPartner";
import {PanelChartPerformanceSupplier} from "../../components/Panel/PanelChartPerformanceSupplier";
import {PanelChartPerformanceCustomer} from "../../components/Panel/PanelChartPerformanceCustomer";

/**
 * DashboardPage
 * @constructor
 */
export function DashboardPage() {
  /**
   * context
   */
  const {
    getRoutes
  } = useContext(AppContext);

  /**
   * routes
   */
  const ROUTE_CONFIG = getRoutes();

  /**
   * the sub panels sit directly in the grid: a wrapper panel around them
   * repeated the breadcrumb's "Übersicht" as a second visible page title and
   * nested panels inside a panel
   */
  return (
    <>
      <Helmet>
        <title>{ ROUTE_CONFIG.DASHBOARD.title }</title>
        <meta
          name="description"
          content={ ROUTE_CONFIG.DASHBOARD.title }
        />
      </Helmet>
      <article>
        <dia-grid-nested data-grid-nested-full-width>
          <dia-grid-row data-grid-column-stretch>
            <dia-grid-column>
              <PanelChartClientData></PanelChartClientData>
            </dia-grid-column>
          </dia-grid-row>
          <dia-grid-row data-grid-column-stretch>
            <dia-grid-column>
              <PanelChartPerformanceSupplier></PanelChartPerformanceSupplier>
            </dia-grid-column>
          </dia-grid-row>
          <dia-grid-row data-grid-column-stretch>
            <dia-grid-column>
              <PanelChartPerformanceCustomer></PanelChartPerformanceCustomer>
            </dia-grid-column>
          </dia-grid-row>
          <dia-grid-row data-grid-column-stretch>
            <dia-grid-column>
              <PanelMatrixPartner></PanelMatrixPartner>
            </dia-grid-column>
          </dia-grid-row>
        </dia-grid-nested>
      </article>
    </>
  );
}
